import { Stack } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import TextInputField from '../../fields/text-input-field/text-input-field.component'
import SelectField, { Option } from '../../select-field/select-field.component'
import SuggestionAutocompleteField from '../../fields/suggestion-autocomplete-field/suggestion-autocomplete-field.component'
import {
  licensePlateStates,
  tractorEquipmentTypes,
  trailerEquipmentTypes,
} from '../../../pages/equipment/data/equipment-options'

const toUpperAlphanumericDashSpace = (value: string) =>
  value.toUpperCase().replace(/[^A-Z0-9 -]/g, '')

const toVinNumber = (value: string) =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 17)

const AddEquipmentForm = () => {
  const { getValues, setValue } = useFormContext()
  const equipmentType = useWatch({ name: 'equipmentType' })

  const equipmentOptions: Option[] = [
    { label: 'Tractor', value: 'TRACTOR' },
    { label: 'Trailer', value: 'TRAILER' },
  ]

  const equipmentTypeOptions =
    equipmentType === 'TRAILER' ? trailerEquipmentTypes : tractorEquipmentTypes

  const stateOptions = useMemo(
    () =>
      [...licensePlateStates].sort((a, b) => a.name.localeCompare(b.name)),
    []
  )

  useEffect(() => {
    const currentCode = getValues('equipmentTypeCode')
    if (
      currentCode &&
      !equipmentTypeOptions.some((option) => option.code === currentCode)
    ) {
      setValue('equipmentTypeCode', '')
    }
  }, [equipmentType, equipmentTypeOptions, getValues, setValue])

  return (
    <Stack spacing={2}>
      <SelectField
        name="equipmentType"
        options={equipmentOptions}
        label="Type *"
        labeldirection="column"
        required
        fullWidth
      />
      <TextInputField
        name="unitNumber"
        label="Unit Number *"
        required
        transform={toUpperAlphanumericDashSpace}
      />
      <SuggestionAutocompleteField
        name="equipmentTypeCode"
        label="Equipment Type Code (Required for ACE)"
        options={equipmentTypeOptions}
      />
      <TextInputField name="licensePlateNumber" label="License Plate Number" />
      <SuggestionAutocompleteField
        name="stateProvince"
        label="License Plate State/Province"
        options={stateOptions}
      />
      <TextInputField
        name="vinNumber"
        label="VIN Number (Required for ACE)"
        placeholder="17 alphanumeric characters"
        transform={toVinNumber}
        maxLength={17}
      />
    </Stack>
  )
}

export default AddEquipmentForm
